export default function TermsPage() {
  return (
    <div
      style={{
        fontFamily: "Inter, sans-serif",
        padding: "40px 20px",
        maxWidth: "900px",
        margin: "0 auto",
        color: "#333",
      }}
    >
      <h1 style={{ fontSize: "28px", fontWeight: "700", marginBottom: "10px" }}>
        Regulamin
      </h1>
      <p style={{ color: "#666", marginBottom: "30px" }}>
        Regulamin serwisu LunGO
        <br />
        Zasady korzystania z serwisu i aplikacji LunGO przez Klientów i
        Restauracje.
        <br />
        <strong>Data aktualizacji:</strong> 23.10.2025
      </p>

      <h2>Spis treści:</h2>
      <ol>
        <li>Definicje</li>
        <li>Informacje o Operatorze</li>
        <li>Zakres usług i charakter platformy</li>
        <li>Konto i dane użytkownika</li>
        <li>Zamówienia i zawarcie umowy</li>
        <li>Ceny, opłaty i podatki</li>
        <li>Dostawa i odbiór</li>
        <li>Płatności</li>
        <li>Odpowiedzialność</li>
        <li>Reklamacje</li>
        <li>Prawo odstąpienia</li>
        <li>Dostępność usług i zmiany</li>
        <li>Ochrona danych</li>
        <li>Własność intelektualna</li>
        <li>Postanowienia końcowe</li>
        <li>Kontakt</li>
      </ol>

      <h2 style={{ marginTop: "30px" }}>1. Definicje</h2>
      <p>
        <strong>Operator/LunGO</strong> – serwis internetowy i/lub aplikacje
        umożliwiające składanie zamówień u Restauracji współpracujących.
        <br />
        <strong>Restauracja</strong> – przedsiębiorca oferujący produkty/usługi
        gastronomiczne za pośrednictwem LunGO.
        <br />
        <strong>Klient</strong> – osoba składająca zamówienie w Restauracji
        poprzez LunGO.
        <br />
        <strong>Umowa sprzedaży</strong> – umowa zawierana bezpośrednio pomiędzy
        Klientem a Restauracją.
        <br />
        <strong>Konto</strong> – profil użytkownika w LunGO.
      </p>

      <h2 style={{ marginTop: "30px" }}>2. Informacje o Operatorze</h2>
      <p>
        Administratorem serwisu jest <strong>Burgizza Sp. z o.o.</strong>, ul.
        Kalwaryjska 69/9, 30-504 Kraków, NIP: 6793328967, REGON: 541513700.
        <br />
        Kontakt: <a href="mailto:support@lungoapp.pl">support@lungoapp.pl</a>.
      </p>

      <h2 style={{ marginTop: "30px" }}>
        3. Zakres usług i charakter platformy
      </h2>
      <ul>
        <li>
          LunGO udostępnia narzędzia do przyjmowania zamówień online przez
          Restauracje.
        </li>
        <li>
          LunGO nie jest stroną Umowy sprzedaży – odpowiedzialność za realizację
          zamówienia ponosi Restauracja.
        </li>
        <li>
          Prezentowane menu, ceny, dostępność i czas dostawy pochodzą od
          Restauracji.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px" }}>4. Konto i dane użytkownika</h2>
      <ul>
        <li>
          Założenie Konta wymaga podania prawdziwych danych (imię, nazwisko,
          e-mail, telefon, adres dostawy – jeśli dotyczy).
        </li>
        <li>Użytkownik odpowiada za bezpieczeństwo dostępu do Konta.</li>
        <li>
          W przypadku nadużyć LunGO może czasowo zablokować lub usunąć Konto.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px" }}>5. Zamówienia i zawarcie umowy</h2>
      <ul>
        <li>
          Złożenie zamówienia następuje po wyborze pozycji z menu i podaniu
          danych kontaktowych/dostawy.
        </li>
        <li>
          Klient otrzymuje e-mailowe potwierdzenie przyjęcia zamówienia (status
          może być aktualizowany przez Restaurację).
        </li>
        <li>
          Umowa sprzedaży zostaje zawarta pomiędzy Klientem a Restauracją w
          momencie przyjęcia zamówienia przez Restaurację.
        </li>
        <li>
          Restauracja może anulować lub zmodyfikować zamówienie m.in. z powodu
          braku produktów lub błędu cenowego – Klient zostanie o tym
          poinformowany.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px" }}>6. Ceny, opłaty i podatki</h2>
      <ul>
        <li>
          Ceny produktów określa Restauracja i zawierają podatki zgodnie z
          przepisami.
        </li>
        <li>
          Opłaty za dostawę/odbiór ustala Restauracja lub jej partner dostawczy.
        </li>
        <li>
          Opłaty platformowe (jeśli występują) są komunikowane przed złożeniem
          zamówienia.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px" }}>7. Dostawa i odbiór</h2>
      <ul>
        <li>
          Dostawę realizuje Restauracja lub jej zewnętrzny kurier; możliwy jest
          odbiór osobisty.
        </li>
        <li>Szacowany czas dostawy ma charakter orientacyjny.</li>
        <li>
          Klient zobowiązany jest zapewnić możliwość kontaktu oraz odbioru w
          miejscu dostawy.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px" }}>8. Płatności</h2>
      <p>
        Aktualnie LunGO nie udostępnia płatności online w serwisie. Restauracje
        mogą przyjmować płatność gotówką lub kartą przy odbiorze (według ich
        zasad).
      </p>
      <p>
        Po wdrożeniu płatności online (np. PayU/Stripe) odpowiednie
        postanowienia zostaną zaktualizowane i udostępnione przed zawarciem
        transakcji.
      </p>

      <h2 style={{ marginTop: "30px" }}>9. Odpowiedzialność</h2>
      <ul>
        <li>
          Za jakość, zgodność i bezpieczeństwo produktów odpowiada Restauracja
          jako sprzedawca.
        </li>
        <li>
          LunGO nie odpowiada za przerwy w dostępności spowodowane siłą wyższą,
          awariami niezależnymi od Operatora lub działaniem osób trzecich.
        </li>
        <li>
          LunGO nie ponosi odpowiedzialności za szkody pośrednie, utracone
          korzyści ani za informacje pochodzące od Restauracji.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px" }}>10. Reklamacje</h2>
      <p>
        Reklamacje dotyczące zamówień (jakość, kompletność, spóźnienie) należy
        kierować bezpośrednio do Restauracji – dane kontaktowe są dostępne w
        potwierdzeniu zamówienia.
      </p>
      <p>
        Wsparcie LunGO:{" "}
        <a href="mailto:support@lungoapp.pl">support@lungoapp.pl</a> – pomagamy
        w przekazaniu sprawy do Restauracji lub wyjaśnieniu statusu.
      </p>

      <h2 style={{ marginTop: "30px" }}>11. Prawo odstąpienia</h2>
      <p>
        W przypadku żywności i napojów przygotowywanych zgodnie ze specyfikacją
        Klienta lub szybko psujących się, prawo do odstąpienia od umowy zawartej
        na odległość może nie przysługiwać zgodnie z przepisami. W innych
        przypadkach należy skontaktować się bezpośrednio z Restauracją.
      </p>

      <h2 style={{ marginTop: "30px" }}>12. Dostępność usług i zmiany</h2>
      <p>
        LunGO może wprowadzać aktualizacje, zmieniać funkcje lub czasowo
        ograniczać dostęp do serwisu. Regulamin może być aktualizowany. Nowa
        wersja obowiązuje od dnia publikacji pod adresem{" "}
        <a
          href="https://lungoapp.pl/terms.html"
          target="_blank"
          rel="noreferrer"
        >
          https://lungoapp.pl/terms.html
        </a>
        .
      </p>

      <h2 style={{ marginTop: "30px" }}>13. Ochrona danych</h2>
      <p>
        Informacje o przetwarzaniu danych znajdują się w{" "}
        <a href="https://lungoapp.pl/privacy" target="_blank" rel="noreferrer">
          Polityce prywatności
        </a>
        . LunGO wysyła wyłącznie e-maile niezbędne do logowania (autoryzacja) i
        potwierdzeń zamówień.
      </p>

      <h2 style={{ marginTop: "30px" }}>14. Własność intelektualna</h2>
      <p>
        Elementy graficzne, oprogramowanie i treści LunGO są chronione prawem.
        Zabronione jest ich kopiowanie, modyfikowanie i rozpowszechnianie bez
        zgody Operatora.
      </p>

      <h2 style={{ marginTop: "30px" }}>15. Postanowienia końcowe</h2>
      <ul>
        <li>
          Prawem właściwym jest prawo polskie, z poszanowaniem przepisów ochrony
          konsumentów.
        </li>
        <li>
          Spory mogą być rozstrzygane polubownie lub przez właściwy sąd
          powszechny.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px" }}>16. Kontakt</h2>
      <p>
        E-mail: <a href="mailto:support@lungoapp.pl">support@lungoapp.pl</a>
        <br />W sprawach prywatności:{" "}
        <a href="mailto:privacy@lungoapp.pl">privacy@lungoapp.pl</a>
        <br />
        Adres korespondencyjny: Burgizza Sp. z o.o., ul. Kalwaryjska 69/9,
        30-504 Kraków.
      </p>
    </div>
  );
}
